import { toast } from "react-toastify";

export const handleUnauthorized = (res, api = "") => {
  if (res.status !== 401) return;
  if (!localStorage.getItem("x-auth-token")) return;
  if (String(api).includes("/login")) return;
  localStorage.clear();
  if (window.location.pathname !== "/") {
    window.location.href = "/";
  }
};

export const messages = async (msg, apiStatus) => {
  if (apiStatus === 1) {
    toast.success(msg + " 😊", {
      style: { backgroundColor: "#6f8f76", color: "#fff" },
    });
  } else {
    toast.error(msg + " 😔", {
      style: { backgroundColor: "#b75b52", color: "#fff" },
    });
  }
};

export const postApi = async (api, type, body, successMsg) => {
  const res = await fetch(api, {
    method: type,
    headers: {
      "Content-Type": "application/json",
      "x-auth-token": localStorage.getItem("x-auth-token"),
    },
    body: JSON.stringify(body),
    // redirect: "follow",
  });
  handleUnauthorized(res, api);
  return await res.json();
};

export const allApi = async (api, type, successMsg) => {
  const res = await fetch(api, {
    method: type,
    headers: {
      "Content-Type": "application/json",
      "x-auth-token": localStorage.getItem("x-auth-token"),
    },
  });
  handleUnauthorized(res, api);
  return await res.json();
};

export const postApiFile = async (api, type, userDetails) => {
  const formData = new FormData();
  Object.entries(userDetails).map(([key, value]) => {
    formData.append(key, value);
  });
  const myHeaders = new Headers();
  myHeaders.append("x-auth-token", localStorage.getItem("x-auth-token"));
  const res = await fetch(api, {
    method: type,
    body: formData,
    headers: myHeaders,
  });
  handleUnauthorized(res, api);
  return await res.json();
};

// export const multiFileUpload = async (api, type, userDetails) => {
//   const formData = new FormData();
//   formData.append("product", userDetails?.product);
//   formData.append("defaultImage", userDetails?.defaultImage);
//   userDetails?.images.forEach((image, index) => {
//     formData.append(`images[${index}]`, image);
//   });
//   const myHeaders = new Headers();
//   myHeaders.append("x-auth-token", localStorage.getItem("x-auth-token"));
//   const res = await fetch(api, {
//     method: type,
//     body: formData,
//     headers: myHeaders,
//   });
//   return await res.json();
// };

export const sendDynamicFormData = async (api, type, userDetails) => {
  const formData = new FormData();
  const buildFormData = (data, parentKey = "") => {
    Object.entries(data).forEach(([key, value]) => {
      const formKey = parentKey ? `${parentKey}[${key}]` : key;
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (typeof item === "object" && item !== null && !(item instanceof File)) {
            // Array of objects (e.g., products[0][name])
            buildFormData(item, `${formKey}[${index}]`);
          } else {
            // Array of files or simple values
            formData.append(`${formKey}[${index}]`, item);
          }
        });
      } else if (typeof value === "object" && value !== null && !(value instanceof File)) {
        // Nested object
        buildFormData(value, formKey);
      } else {
        // Primitive or File
        formData.append(formKey, value);
      }
    });
  };
  buildFormData(userDetails);
  const headers = new Headers();
  headers.append("x-auth-token", localStorage.getItem("x-auth-token"));
  const res = await fetch(api, {
    method: type,
    body: formData,
    headers,
  });
  handleUnauthorized(res, api);
  return await res.json();
};


export const fileWithObjArray = async (api, type, userDetails) => {
  const formData = new FormData();
  Object.entries(userDetails).map(([key, value]) => {
    formData.append(key, value);
  });
  const myHeaders = new Headers();
  myHeaders.append("x-auth-token", localStorage.getItem("x-auth-token"));
  const res = await fetch(api, {
    method: type,
    body: formData,
    headers: myHeaders,
  });
  handleUnauthorized(res, api);
  return await res.json();
};
